var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('status-badge',{key:_vm.order.transactionnum,attrs:{"label":_vm.resolved.label,"icon":_vm.resolved.icon,"color":_vm.resolved.color,"color-class":_vm.resolved.colorClass,"addon":_vm.resolved.addon}})}
var staticRenderFns = []

export { render, staticRenderFns }